/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import React from 'react'
import { Tooltip } from 'reactstrap'

export interface ITabTooltipProps {
	toolTipContent: string
	targetId: string
}

interface ITabTooltipState {
	tooltipOpen: boolean
}

export class TabTooltipComponent extends React.Component<ITabTooltipProps, ITabTooltipState> {
	constructor(props: Readonly<ITabTooltipProps>) {
		super(props)
		this.toggle = this.toggle.bind(this)
		this.state = { tooltipOpen: false }
	}

	toggle(): void {
		this.setState({ tooltipOpen: !this.state.tooltipOpen })
	}

	render(): React.ReactNode {
		return (
			<>
				<span style={{ cursor: 'pointer' }} id={this.props.targetId}>
					<img alt="tooltip" src="/coveragediscovery/img/icon-tooltip-small.png" />
				</span>
				<Tooltip placement="top" isOpen={this.state.tooltipOpen} autohide={false} target={this.props.targetId} toggle={this.toggle}>
					{this.props.toolTipContent}
				</Tooltip>
			</>
		)
	}
}
